import { Patient } from "@mgdx/shared/src/models/Patient";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { currentPatientQueryOptions } from "./currentPatientQuery";

export type ApiResponseData = Patient;
type ApiError = Response;
type QueryResponseData = boolean;

type QueryOptions = Omit<
  UseQueryOptions<ApiResponseData, ApiError, QueryResponseData>,
  "queryKey" | "queryFn" | "onError" | "select"
>;

type UseCurrentPatientIsMedicineNotebookUsingQuery = {};

export const useCurrentPatientIsMedicineNotebookUsingQuery = (
  _: UseCurrentPatientIsMedicineNotebookUsingQuery,
  options?: QueryOptions
) => {
  const { data, isLoading, isPending, isSuccess, isError, error } = useQuery<
    ApiResponseData,
    ApiError,
    QueryResponseData
  >({
    ...currentPatientQueryOptions,
    select: (data) => {
      if (!data.medicineNotebooks || data.medicineNotebooks.length === 0) {
        return false;
      }
      return data.medicineNotebooks[0].agreed || false;
    },
    ...options,
  });

  return { data, isLoading, isPending, isSuccess, isError, error };
};
